import { SiteSectionIds } from '../contentful';
import CvgLogo from '../assets/cvg-logo.svg';
import OXDLogo from '../assets/oxd-logo.svg';

export const siteSectionIdToLogoMap: {
	[key in SiteSectionIds]?: SVGComponent;
} = {
	[SiteSectionIds.OXD]: OXDLogo,
};

export const getSiteSectionLogo = (currentSiteSectionId: SiteSectionIds) =>
	siteSectionIdToLogoMap[currentSiteSectionId] ?? CvgLogo;
